import BaseModelInstance from './base.model'
import { CarrierProduct as ModelDefinition } from './model-definitions'

class CarrierProduct extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default CarrierProduct
